export default __webpack_public_path__ + "static/media/logo-horizontal-black.c07233b9.png";